import Spinner from '@atlaskit/spinner';
import { bannerDefaults } from 'constants/strings';
import * as PropTypes from 'prop-types';
import React from 'react';
import { Loading, Message } from './styles';

/**
 * Loading message banner.
 * @param {Object} props - Component properties
 */
const LoadingBanner = (props) => {
  const { message, style } = props;
  return (
    <Loading style={style}>
      <div style={{ opacity: 0.5 }}>
        <Spinner size="large" delay={0} data-test-id='loading-banner-icon'/>
      </div>
      <Message data-test-id='loading-banner-message'>{message}</Message>
    </Loading>
  );
};

LoadingBanner.propTypes = {
  message: PropTypes.string,
  style: PropTypes.object
};

LoadingBanner.defaultProps = {
  message: bannerDefaults.LOADING,
  style: {}
};

export default LoadingBanner;
